
// Simple event bus for cache invalidation events
type CacheEventHandler = (payload: any) => void;
export type CacheEventType = 'knowledgeUpdated' | 'topicUpdated' | 'languageUpdated' | 'contentRelationshipChanged';

class CacheEventBus {
  private listeners: Record<string, CacheEventHandler[]> = {};
  
  subscribe(event: CacheEventType, handler: CacheEventHandler) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(handler);
    
    // Return unsubscribe function
    return () => {
      this.listeners[event] = this.listeners[event].filter(h => h !== handler);
    };
  }
  
  publish(event: CacheEventType, payload: any) {
    if (!this.listeners[event]) return;
    
    this.listeners[event].forEach(handler => {
      try {
        handler(payload);
      } catch (error) {
        console.error(`Error in cache event handler for ${event}:`, error);
      }
    });
  }
}

// Create a singleton event bus
export const cacheEventBus = new CacheEventBus();
